import { ApiUrl, ApiUrlAdmin } from "../common/Config";
import { postAdmin, post, get, getAdmin, postFormData,put } from "../common/Helper";



export const getLogs = async (data, token) => {
    let url = ApiUrl + `AppLogs/getLogs`;
    return await post(url,data, token);
  };